export const useDebounce = (callback: (...args: any[]) => void, wait = 0) => {
  let timeoutId: string | number | NodeJS.Timeout | undefined;

  return (...args: any[]) => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => callback(...args), wait);
  };
};
